const n = {
  "loading-spinner": "loading-spinner",
  "loading-spinner__text": "loading-spinner__text"
};
export {
  n as default
};
